import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-new-roof-cost-certifications',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule],
  templateUrl: './new-roof-cost-certifications.component.html',
  styleUrl: './new-roof-cost-certifications.component.scss',
})
export class NewRoofCostCertificationsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('swiperRef') swiperRef!: ElementRef<HTMLElement>;

  partners = [
    { logo: 'certified-by/master-elite.png', webp: 'master-elite.webp' },
    { logo: 'certified-by/google-review.png', webp: 'google-review.webp' },
    { logo: 'certified-by/certain-teed.png', webp: 'certain-teed.webp' },
    { logo: 'certified-by/wwens_corning.png', webp: 'wwens_corning.webp' },
    { logo: 'certified-by/bbb-logo.png', webp: 'bbb-logo.webp' },
    { logo: 'certified-by/cert1.png', webp: 'certified-by/cert1.png' },
    { logo: 'certified-by/cert2.png', webp: 'certified-by/cert2.png' },
    { logo: 'certified-by/cert3.png', webp: 'certified-by/cert3.png' },
    { logo: 'certified-by/cert4.png', webp: 'certified-by/cert4.png' },
    { logo: 'certified-by/cert5.png', webp: 'certified-by/cert5.png' },
    { logo: 'certified-by/cert6.png', webp: 'certified-by/cert6.png' },
    { logo: 'certified-by/cert7.png', webp: 'certified-by/cert7.png' },
    { logo: 'certified-by/cert8.png', webp: 'certified-by/cert8.png' },
  ];

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (typeof window === 'undefined') return;
    const el = this.swiperRef?.nativeElement as HTMLElement & {
      initialize?: () => void;
      swiper?: { isBeginning: boolean; isEnd: boolean };
    };
    if (!el || typeof el.initialize !== 'function') return;

    Object.assign(el, {
      spaceBetween: 24,
      slidesPerView: 'auto',
      loop: true,
      loopedSlides: this.partners.length,
      centeredSlides: false,
      autoplay: { delay: 2000, disableOnInteraction: false },
      speed: 400,
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 16, centeredSlides: true },
        768: { slidesPerView: 2, spaceBetween: 24, centeredSlides: false },
        1250: { slidesPerView: 3, spaceBetween: 30, centeredSlides: false },
      },
      on: {
        init: () => {
          this.updateBounds(el);
          this.cdr.markForCheck();
        },
        slideChange: () => {
          this.updateBounds(el);
          this.cdr.markForCheck();
        },
      },
    });
    setTimeout(() => {
      if (el.children.length > 0 && typeof el.initialize === 'function') el.initialize();
    }, 100);
  }

  ngOnDestroy(): void {
    const el = this.swiperRef?.nativeElement as HTMLElement & { swiper?: { autoplay?: { stop: () => void } } };
    if (el?.swiper?.autoplay) el.swiper.autoplay.stop();
  }

  private updateBounds(el: HTMLElement & { swiper?: { isBeginning: boolean; isEnd: boolean } }): void {
    const swiper = el.swiper;
    if (!swiper) return;
  }

  prev(): void {
    const el = this.swiperRef?.nativeElement as HTMLElement & { swiper?: { slidePrev: () => void } };
    if (!el?.swiper) return;
    el.swiper.slidePrev();
  }

  next(): void {
    const el = this.swiperRef?.nativeElement as HTMLElement & { swiper?: { slideNext: () => void } };
    if (!el?.swiper) return;
    el.swiper.slideNext();
  }
}
